import { List, Tooltip, Typography } from 'antd'

import { V3Transaction } from 'models/v3-transaction'
import TotalCard from 'atom/cards/TotalCard'
import { ListCardWrapper } from 'atom/list'
import { formatPrice } from 'helpers/number-format'
import { theme } from 'theme'

interface props {
  transaction: V3Transaction
}

const TransactionPanelRefund: React.FC<props> = ({ transaction }) => {
  const refund = transaction.refund
  if (!refund) return null

  const currency = transaction.financial?.currency ?? 'USD'
  const refundToLabel = `Refund to ${refund.paymentGateway?.toLowerCase() === 'stripe' ? 'Card' : 'Wallet'}`
  const stateColor =
    refund.state === 'succeeded'
      ? theme.colors.neonGreen
      : refund.state === 'failed'
        ? theme.colors.dangerPrimary
        : theme.colors.black
  const stateDisplay =
    refund.state === 'succeeded'
      ? <span style={{ color: stateColor }}>Succeeded</span>
      : refund.state === 'failed'
        ? refund.paymentErrorMsg ? (
            <Tooltip title={refund.paymentErrorMsg} overlayInnerStyle={{ textAlign: 'center', maxWidth: 200 }}>
              <span style={{ color: stateColor, cursor: 'pointer', textDecoration: 'underline' }}>Failed</span>
            </Tooltip>
          ) : (
            <span style={{ color: stateColor }}>Failed</span>
          )
        : <span style={{ color: stateColor }}>{refund.state}</span>

  return (
    <ListCardWrapper>
      <TotalCard>
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Refund</div>
        <List.Item
          className="hideBorderBottom"
          actions={[<span className="heading-06-regular-td">{formatPrice(refund.refundTotalCents / 100, currency)}</span>]}
        >
          <List.Item.Meta title="Amount:" />
        </List.Item>
        <List.Item
          className="hideBorderBottom"
          actions={[
            refund.reason ? (
              <Typography.Text
                style={{ color: theme.colors.black, maxWidth: 250 }}
                ellipsis={{ tooltip: refund.reason }}
              >
                {refund.reason}
              </Typography.Text>
            ) : (
              <span style={{ color: theme.colors.black }}>-</span>
            ),
          ]}
        >
          <List.Item.Meta title="Reason:" />
        </List.Item>
        <List.Item actions={[stateDisplay]}>
          <List.Item.Meta title={refundToLabel} />
        </List.Item>
      </TotalCard>
    </ListCardWrapper>
  )
}

export default TransactionPanelRefund
